import { render, staticRenderFns } from "./MetadadosCampoDinamicoRadio.vue?vue&type=template&id=9ab3d3d6&"
import script from "./MetadadosCampoDinamicoRadio.vue?vue&type=script&lang=js&"
export * from "./MetadadosCampoDinamicoRadio.vue?vue&type=script&lang=js&"
import style0 from "./MetadadosCampoDinamicoRadio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRadio,VRadioGroup,VRow})
